'use client';
export { default as useAuthModal } from './hooks/useAuthModal';
import type { Session as SessionEnhanced } from './interfaces';

export { useSession, signIn, signOut } from 'next-auth/react';

export type Session = SessionEnhanced;
